export const marketplaceUrl = process.env.NEXT_PUBLIC_MARKETPLACE_API_URL;
export const googleMapsKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY;
export const marketplaceWeb = process.env.NEXT_PUBLIC_MARKETPLACE_URL;
export const marketplaceCdn = process.env.NEXT_PUBLIC_APP_URL_S3;
// export const marketplaceCdn = process.env.NEXT_PUBLIC_APP_URL_S3
export const googleAnalytics = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS;
